module.exports = __webpack_public_path__ + "img/chapter.8b6082fe.svg";